import {logger} from "@services/logger/logger.service";

export function calculateBytes(str: string): number {
    const encoder = new TextEncoder();
    const bytes = encoder.encode(str);
    return bytes.length;
}

export function checkAndCutByBytes(str: string, maxBytes: number): Promise<string> {
    return new Promise((resolve, reject) => {
        try {
            const valueLengthInBytes = calculateBytes(str);
            if (valueLengthInBytes <= maxBytes) {
                resolve(str);
            }

            let byteLength = 0;
            let truncatedString = '';

            for (let i = 0; i < str.length; i++) {
                const charCode = str.charCodeAt(i);
                const charSize = charCode < 0x0080 ? 1 : 2; // ASCII characters are 1 byte, others are 2 bytes

                if (byteLength + charSize <= maxBytes) {
                    truncatedString += str[i];
                    byteLength += charSize;
                }
            }
            resolve(truncatedString);
        } catch (e) {
            logger.error(e);
            reject(e)
        }
    })
}

export function safeJsonParse(data: string): string {
    try {
        return JSON.parse(data)
    } catch (e) {
        logger.error(e)
        return data
    }
}
